import { gql } from '@apollo/client'

export const UPDATE_EMPLOYEE_BY_ID = gql`
  mutation updateUser($input: UpdateUserInput!) {
    data: updateUser(input: $input) {
      id
    }
  }
`
